<template functional>
  <svg
    role="presentation"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="props.size"
    :height="props.size"
    viewBox="0 0 16 16"
  >
    <g transform="translate(0.08 0.1)">
      <path
        d="M10,13.349H2a2,2,0,0,1-2-2V5.523A2,2,0,0,1,.667,4.016l4-3.507a2,2,0,0,1,2.667,0l4,3.507A2,2,0,0,1,12,5.516v5.834A2,2,0,0,1,10,13.349ZM5.333,6.682H6.667a2,2,0,0,1,2,2v3.333H10a.668.668,0,0,0,.667-.667V5.516a.668.668,0,0,0-.227-.5l-4-3.5a.666.666,0,0,0-.879,0l-4,3.5a.664.664,0,0,0-.226.5v5.834A.667.667,0,0,0,2,12.016H3.333V8.683A2,2,0,0,1,5.333,6.682Zm0,1.334a.667.667,0,0,0-.666.667v3.333H7.334V8.683a.668.668,0,0,0-.667-.667Z"
        transform="translate(2 1.317)"
        fill="#7b8190"
        stroke-width="0"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconHouse',

  props: {
    size: { type: [String, Number], default: '16px' },
  }
}
</script>